import { atom } from "recoil";

export const allProductsState = atom({
  key: "allProductsState",
  default: null,
});

export const allCategoriesState = atom({
  key: "allCategoriesState",
  default: null,
});

export const tableDataState = atom({
  key: "tableDataState",
  default: null,
});
